import WarningBox from './WarningBox';

export default WarningBox; 